import { Manager } from '../Manager';
import Core from '../../Core/Core';
import Board from '../Board/Board';
import { Actions } from '../../State/Actions/Actions';
import { BoosterUtils } from './BoosterUtils';

export default class Firecracker extends Manager {
    private board: Board;

    constructor(board: Board) {
        super();

        this.board = board;
    }

    public cleanUp() {
        super.cleanUp();
    }

    public async triggerTileBursts() {
        const state = Core.store.getState();
        const {
            StateBoard: { boardMap },
        } = state;
        const bursts = BoosterUtils.startTileBursts(state, boardMap, this.countBurst.bind(this));
        await bursts;
        this.completeBursts();
    }

    private countBurst(i: number, id: string, score: number) {
        if (i % 2 === 0) {
            Core.store.dispatch(Actions.setMultiplier(1));
        }

        this.board.blowUpTile(id, score);
        Core.store.dispatch(Actions.addScore(score));
        Core.store.dispatch(Actions.removeStoredPairs(id));
    }

    private completeBursts() {
        if (!Core.store.getState().StateLevel.complete) {
            Core.store.dispatch(Actions.boosterActionComplete());
        }
    }
}
